/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewTech } from './CRSFSecReviewTech';
import {
    CRSFSecReviewTechFromJSON,
    CRSFSecReviewTechFromJSONTyped,
    CRSFSecReviewTechToJSON,
} from './CRSFSecReviewTech';

/**
 * 
 * @export
 * @interface CRSFSecReviewTechsPagedResponse
 */
export interface CRSFSecReviewTechsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTechsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTechsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewTech>}
     * @memberof CRSFSecReviewTechsPagedResponse
     */
    results?: Array<CRSFSecReviewTech>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTechsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewTechsPagedResponse interface.
 */
export function instanceOfCRSFSecReviewTechsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewTechsPagedResponseFromJSON(json: any): CRSFSecReviewTechsPagedResponse {
    return CRSFSecReviewTechsPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewTechsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewTechsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewTechFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewTechsPagedResponseToJSON(value?: CRSFSecReviewTechsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewTechToJSON)),
        'total': value.total,
    };
}

